<div class="h100 flex-col">
  <div class="flex-row space-between align-center p-16">
    <span class="subheading-2 on-background">{{'dashboard_ui.modules' | trans}}</span>
    <mat-icon class="on-disabled cursor-pointer" (click)="dialogRef.close()">close</mat-icon>
  </div>

  <div class="divider-on-disabled"></div>


  <cdk-accordion class="w100 overflow-scroll" [multi]="true">
    @for (item of dashboardFacade.panelWidget(); track item.name; let index = $index) {
      <cdk-accordion-item
        #accordionItem="cdkAccordionItem"
        class="w100 cursor-pointer"
        role="button"
        tabindex="0">
        <div class="flex-row gap-16 align-center p-16" (click)="accordionItem.toggle()">
          <mat-icon class="on-background-alt">{{ item.icon }}</mat-icon>
          <span class=" button grow on-background">{{ item.name | trans }}</span>
          @if (accordionItem.expanded) {
            <mat-icon class="on-background-alt">keyboard_arrow_up</mat-icon>
          } @else {
            <mat-icon class="on-background-alt">keyboard_arrow_down</mat-icon>
          }
        </div>
        @if (accordionItem.expanded) {
          <div class="w100 bg-canvas p-16 flex-col gap-16 border-box">
            @for (module of item.modules; track module.type) {
              <div class="p-16 bg-background border-8 flex-col gap-8 border-box">
                <div class="flex-row align-center">
                  <div class="big-icon bg-on-disabled">
                    <mat-icon class="canvas">{{ module.icon }}</mat-icon>
                  </div>
                  @if (module.enabled) {
                    <vl-chips class="ml-auto" iconLeft="check" [state]="'active'"
                              (action)="removeWidget(module.type)">{{ 'dashboard_ui.ajoute' | trans }}
                    </vl-chips>
                  } @else {
                    <vl-chips class="ml-auto" iconRight="add_box" [state]="'enabled'"
                              (action)="addWidget(module.type)">{{ 'dashboard_ui.ajouter_widget' | trans }}
                    </vl-chips>
                  }
                </div>
                <div class="w100 flex-col">
                  <span class="body-2 on-background">{{ module.name | trans }}</span>
                  @if (module.description) {
                    <span class="on-background-alt caption">{{ module.description | trans }}</span>
                  }
                </div>

              </div>
            }
          </div>
        }
      </cdk-accordion-item>
    }
  </cdk-accordion>

  <div class="divider-on-disabled"></div>

  @if (dashboardFacade.canEditGlobal()) {
    <div class="flex-col gap-8 p-8">
      <vl-chips (action)="showGlobalDashboard()"
                [state]="dashboardFacade.getState().globalDashboard() ? 'active' : 'enabled'">{{ 'dashboard_ui.par_defaut' | trans }}
      </vl-chips>
      <vl-chips (action)="showPersoDashboard()"
                [state]="dashboardFacade.getState().globalDashboard() ? 'enabled' : 'active'">{{ 'dashboard_ui.mon_dashboard' | trans }}
      </vl-chips>
    </div>
  }

  @if (!dashboardFacade.getState().globalDashboard() && dashboardFacade.getState().dashboard()?.userId) {

    <div class="divider-on-disabled"></div>
    <div class="flex-row p-8 w100 border-box">
      <vl-big-button class="w100" color="error" [text]="'dashboard_ui.reinitialiser' | trans" (action)="resetDashboard()"/>
    </div>
  }


</div>
